import { render, staticRenderFns } from "./GlobalSearchResult.vue?vue&type=template&id=721f1bda&"
import script from "./GlobalSearchResult.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports